import { Component, Vue, Watch } from 'vue-property-decorator';

import { proxyfetch } from 'tivigi/src/util/proxyfetch';
import { tryToRead } from 'tivigi/src/util/tryToRead';


import Data from 'tivigi/src/components/data/Data/Data'

import WithRender from './SM2Base.html';
import './statistikmonitor.scss'

@WithRender
@Component({
    components: { Data }
})
export default class SM2Base extends Vue {

    spatialUnits = new Array<any>()
    indicators = new Array<any>()
    categories = Array<string>()

    printTrigger:boolean = false;

    showGlossary = false
    glossaryContent : string|undefined = "<strong>Hallo</strong>"

    local:any={};
    
    glossaryUrl : string|null = null


    getCategoriesWithIndicatorTypes(itypes: Array<string>): Array<string> {

        let result = Array<string>()

        for (let c of this.categories) {
            for (let type of itypes) {
                if (this.indicatorsExistFor(c, type) && !result.includes(c)) {
                    result.push(c)
                }
            }
        }

        return result
    }


    getCssClass(spatialUnit: any): string {


        if (spatialUnit.properties.id == "Z0040") {
            return "compare-mrn"
        }

        if (spatialUnit.properties.id == "Z0060") {
            return "compare-mrn"
        }

        return "";
    }


    getGlossaryLink(icode: string): string {

        const indicator = this.getIndicator(icode)

        if (indicator == null || indicator == undefined) {
            console.log("Indicator not found: " + icode)
            return ""
        }
        
        return indicator.glossary_url        
    }



    getIndicator(indicatorCode: string): any | null {
        for (let i of this.indicators) {
            if (i.code == indicatorCode) {
                return i
            }
        }

        return null
    }


    getLatestYear(su: any, indicatorCode: string): string | any {

        let years = Array<any>();

        for (let key in su.properties) {

            if ((key as string).startsWith(indicatorCode)) {

                // ATTENTION: This assumes that there is only one '_' in the 
                // key and that the part after the '_' is the year!
                let pair = key.split('_')

                if (pair.length == 2) {
                    let year = pair[1]

                    if (year != null && !years.includes(year)) {
                        years.push(year)
                    }
                }
            }
        }

        if (years.length > 0) {
            return years.sort()[years.length - 1]
        }

        return null
    }


    getSpatialUnit(suid: string): any {
        for (let su of this.spatialUnits) {
            if (su.properties.id == suid) {
                return su
            }
        }

        return null
    }


    getSpatialUnits(types: Array<string>) {
        let result = Array<any>()

        for (let su of this.spatialUnits) {
            if (types.includes(su.properties.type.toUpperCase())) {
                result.push(su)
            }
        }

        return result.sort((a, b) => { if (a.properties.name > b.properties.name) return 1; if (a.properties.name < b.properties.name) return -1; return 0; })
    }


    getValue(spatialUnit: any, indicatorCode: string, year: any) {

        return spatialUnit.properties[indicatorCode + "_" + year]
    }


    getYears(indicatorCode: any) {

        let result = Array<any>()

        for (let su of this.spatialUnits) {

            for (let key in su.properties) {
                if ((key as string).startsWith(indicatorCode)) {

                    // ATTENTION: This assumes that there is only one '_' in the 
                    // key and that the part after the '_' is the year!
                    let pair = key.split('_')

                    if (pair.length == 2) {

                        if (!result.includes(pair[1])) {
                            result.push(pair[1])
                        }
                    }
                }
            }
        }

        return result.sort((a, b) => { if (a < b) return 1; if (a > b) return -1; return 0; })
    }


    getIndicators(category: string | null, type: string): Array<any> {

        let result = Array<any>()

        for (let indicator of this.indicators) {
            if (indicator.type == type) {
                if (category == null || indicator.category == category) {
                    result.push(indicator)
                }
            }
        }

        return result
    }


    indicatorsExistFor(category: string, itype: string): boolean {
        return this.getIndicators(category, itype).length > 0
    }


    created() {

        let p1 = proxyfetch("statistikmonitor2/allinone.json").then(response => response.json())
        let p2 = proxyfetch("statistikmonitor2/indicators.json").then(response => response.json())

        Promise.all([p1, p2]).then(this.onDataLoaded2)
    }


    onDataLoaded2(data_array: any) {

        this.spatialUnits = data_array[0].features
        this.indicators = data_array[1]

        for (let indicator of this.indicators) {
            if (!this.categories.includes(indicator.category)) {
                this.categories.push(indicator.category)
            }
        }

   //     this.categories = this.categories.sort()
    }


    print() {
        window.print()
    }


    openGlossary(url: string) {
   
        //let url = "https://metropolatlas.digitale-mrn.de/processwire/dashboards/glossar/" + url + "/"

        this.glossaryUrl = url
        this.showGlossary = true
    }



    tryToRead(root: any, path: string) {
        return tryToRead(root, path, undefined)
    }
}


